export enum CourseEnum {
  Rookie = 35,
  Intermediate = 36,
  Advanced = 37
}